import { render, staticRenderFns } from "./DialogInstanceView.vue?vue&type=template&id=484c11e2&scoped=true&"
import script from "./DialogInstanceView.vue?vue&type=script&lang=js&"
export * from "./DialogInstanceView.vue?vue&type=script&lang=js&"
import style0 from "./DialogInstanceView.vue?vue&type=style&index=0&id=484c11e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484c11e2",
  null
  
)

export default component.exports